module.exports = __webpack_public_path__ + "img/fast-operate.15437e37.svg";